module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-tabs', {
    staticClass: "tab-nav",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "申报中"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "申报成功"
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.goDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "justify-space-flex row-title"
    }, [_c('div', {
      staticClass: "title-left flex-start gray"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": "https://static.dierqudao.com/images/dinghuoxitong/icon-date.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.create_time_str) + " 申报")])])]), _vm._v(" "), _c('div', {
      staticClass: "justify-space-flex row-goods"
    }, [_c('div', {
      staticClass: "row-left flex-start"
    }, [_c('div', {
      staticClass: "goods-detail"
    }, [(order.member_list.length > 0) ? _c('div', {
      staticClass: "goods-name"
    }, [_vm._l((order.member_list), function(member, mkey) {
      return (mkey < 4) ? _c('span', {
        key: mkey
      }, [_vm._v(_vm._s(member.name) + " ")]) : _vm._e()
    }), _vm._v("\n                                        等" + _vm._s(order.members) + "人报名\n                                    ")], 2) : _c('div', {
      staticClass: "goods-name"
    }, [_vm._v("\n                                        暂无人员报名\n                                    ")]), _vm._v(" "), _c('div', {
      staticClass: "goods-weight gray-light"
    }, [_vm._v("\n                                        " + _vm._s(order.danwei) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "row-right"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (order.order_price > 0),
        expression: "order.order_price>0"
      }],
      staticClass: "goods-price"
    }, [_c('span', [_vm._v("¥")]), _vm._v(_vm._s(order.order_price))]), _vm._v(" "), _c('div', {
      staticClass: "goods-num gray-light"
    }, [_vm._v("人数 " + _vm._s(order.members))])])]), _vm._v(" "), _c('div', {
      staticClass: "row-btn"
    }, [_c('div', {
      staticClass: "look-order"
    }, [_vm._v("查看详情")])])])
  }), 0)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff8de5b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameApplySList.vue
// module id = 1613
// module chunks = 0